var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.05.737a.93.93 0 00-1.298.214L5.054 13.086 2.15 10.178a.93.93 0 10-1.315 1.315l3.678 3.68a.945.945 0 001.413-.115l9.337-13.023A.93.93 0 0015.05.737z",
    fill: "currentColor"
  })));
}

export default SvgCheck;